/* eslint no-unused-vars: 'off' */

import pick from 'lodash/pick';

import React from 'react';
import Slider from 'rc-slider';
import PropTypes from 'prop-types';

class AlphaSliderComponent extends React.PureComponent {
  get decimalFloat () {
    return (1 - this.props.input.value);
  }

  get decimalString () {
    return parseFloat(this.decimalFloat.toFixed(4));
  }

  render () {
    const { input, meta, ...props } = this.props;

    return (
      <div className="mb-15" data-test="alphaSlider">
        <p className="font-14 opacity-50 mb-10 flex space-between">
          <span>Proportion = {this.decimalString}</span>

          <span>&#945; = {input.value}</span>
        </p>

        <Slider {...props} {...pick(input, ['value', 'onChange'])} />
      </div>
    );
  }
}

AlphaSliderComponent.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
  }).isRequired,

  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,

  meta: PropTypes.any.isRequired,

  className: PropTypes.string,
  step: PropTypes.number
};

AlphaSliderComponent.defaultProps = {
  className: 'main-slider',
  step: 0.01
};

export default AlphaSliderComponent;
